#import "~/graphql/fragments/assets/defaultImageAsset.graphql"

fragment postCardsContent on posts_default_Entry {
    uri
    title
    image {
        ...DefaultImageAsset
    }
    video: videoUrl
    tags {
        title
    }
    postDate
    postTypes: selectPostType {
        title
    }
}
